import { toCsv } from '@/utils/reportCsv';
import type { PostingLogRow } from '@/utils/PostingLog/types';
import { formatDate, formatCurrency } from '@/utils/PostingLog/formatters';

export const POSTING_LOG_CSV_HEADERS = [
  'Timesheet', 'Employee', 'Date', 'Project', 'Cost Centre',
  'Hours', 'Rate', 'Uplift', 'Status', 'ERP Ref', 'Error',
];

export const buildPostingLogCsv = (lines: PostingLogRow[]): string =>
  toCsv(
    POSTING_LOG_CSV_HEADERS,
    lines.map((r) => [
      r.timesheetId, r.employeeName,
      formatDate(r.transactionDate),
      r.projectName, r.costCentreName,
      r.quantity.toFixed(2),
      formatCurrency(r.price),
      r.upliftValue !== 0 ? formatCurrency(r.upliftValue) : '',
      r.status,
      r.erpRef ?? '',
      r.errorMessage ?? '',
    ]),
  );
